<form [formGroup]="milestoneForm" (ngSubmit)="saveMilestone(inProgress)">
  <div class="modal-header">
    <h5 class="modal-title d-flex align-items-center">
      <i class="bx bx-flag me-1 font-20 text-primary"></i>{{milestoneForm.value.id ? 'Update' : 'Add'}} Milestone
    </h5>
    <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
      (click)="activeModal.close('Close')" routerLink="/project-pilot/milestones"></button>
  </div>
  <div class="modal-body">
    <div class="row g-3 mb-2">
      <div class="col-md-3">
        <label for="project" class="form-label">Project <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-book-reader'></i></span>
          <ng-select class="form-control rcx-ng-select" formControlName="projectId" [clearable]="false"
            placeholder="Select Project" [ngClass]="{'is-invalid': submitted && f.projectId.errors}">
            <ng-option *ngFor="let project of projects" [value]="project.id">{{project.name}}</ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="submitted && f.projectId.errors">
            <span *ngIf="f.projectId.errors.required">Please select a project.</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <label for="title" class="form-label">Title <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-user'></i></span>
          <input type="text" class="form-control" id="title" formControlName="title" placeholder="Enter title"
            autocomplete="off" [ngClass]="{'is-invalid': submitted && f.title.errors}" />
          <div class="invalid-feedback" *ngIf="submitted && f.title.errors">
            <span *ngIf="f.title.errors.required">Title is required.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="priority" class="form-label">Priority <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-star'></i></span>
          <ng-select class="form-control rcx-ng-select" formControlName="priority" [clearable]="false"
            placeholder="Select Priority" [ngClass]="{'is-invalid': submitted && f.priority.errors}">
            <ng-option *ngFor="let priority of priorities" [value]="priority">
              <span [ngClass]="getPriorityBadgeClass(priority)">
                {{ priority }}
              </span>
            </ng-option>
            <ng-template ng-label-tmp let-item="item">
              <span [ngClass]="getPriorityBadgeClass(item)">
                {{ item }}
              </span>
            </ng-template>
          </ng-select>
          <div class="invalid-feedback" *ngIf="submitted && f.priority.errors">
            <span *ngIf="f.priority.errors.required">Please select a priority.</span>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label for="estimatedHours" class="form-label">Estimated Hours <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-time'></i></span>
          <input type="number" class="form-control" id="estimatedHours" formControlName="estimatedHours"
            autocomplete="off" placeholder="Enter estimated hours"
            [ngClass]="{'is-invalid': submitted && f.estimatedHours.errors}" />
          <div class="invalid-feedback" *ngIf="submitted && f.estimatedHours.errors">
            <span *ngIf="f.estimatedHours.errors.required">Estimated hours are required.</span>
            <span *ngIf="f.estimatedHours.errors.min">Estimated hours must be at least 0.</span>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label for="startDate" class="form-label">Start Date <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-calendar'></i></span>
          <input type="date" class="form-control" id="startDate" formControlName="startDate" autocomplete="off"
            [ngClass]="{'is-invalid': submitted && f.startDate.errors}" />
          <div class="invalid-feedback" *ngIf="submitted && f.startDate.errors">
            <span *ngIf="f.startDate.errors.required">Start date is required.</span>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label for="deadline" class="form-label">Deadline <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-calendar'></i></span>
          <input type="date" class="form-control" id="deadline" formControlName="deadline" autocomplete="off"
            [ngClass]="{'is-invalid': (submitted && f.deadline.errors) || (submitted && milestoneForm.errors?.invalidDateRange)}" />
          <div class="invalid-feedback" *ngIf="submitted && f.deadline.errors">
            <span *ngIf="f.deadline.errors.required">Deadline is required.</span>
          </div>
          <div class="invalid-feedback" *ngIf="submitted && milestoneForm.errors?.invalidDateRange">
            <span>Deadline cannot be earlier than the start date.</span>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label for="actualHours" class="form-label">Actual Hours</label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-time'></i></span>
          <input type="number" class="form-control" id="actualHours" formControlName="actualHours" autocomplete="off"
            placeholder="Auto-calculated from tasks" readonly
            [ngClass]="{'is-invalid': submitted && f.actualHours.errors}" />
          <div class="invalid-feedback" *ngIf="submitted && f.actualHours.errors">
            <span *ngIf="f.actualHours.errors.min">Actual hours must be at least 0.</span>
          </div>
        </div>
        <small class="form-text">Auto-calculated from hours</small>
      </div>
      <div class="col-md-4">
        <label for="status" class="form-label">Status <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class='bx bx-layer'></i>
          </span>
          <ng-select class="form-control rcx-ng-select" formControlName="status" [clearable]="false"
            placeholder="Select status" [ngClass]="{'is-invalid': submitted && f.status.errors}">
            <ng-option *ngFor="let status of statuses" [value]="status">
              <span [ngClass]="getBadgeClass(status)">
                {{ formatStatus(status) }}
              </span>
            </ng-option>
            <ng-template ng-label-tmp let-item="item">
              <span [ngClass]="getBadgeClass(item)">
                {{ formatStatus(item) }}
              </span>
            </ng-template>
          </ng-select>
          <div class="invalid-feedback" *ngIf="submitted && f.status.errors">
            <span *ngIf="f.status.errors.required">Please select a status.</span>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label for="completedDate" class="form-label">Completion Date</label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-calendar'></i></span>
          <input type="date" class="form-control" id="completedDate" formControlName="completedDate" autocomplete="off"
            [ngClass]="{'is-invalid': submitted && f.completedDate.errors}" />
        </div>
      </div>
      <div class="col-md-12">
        <label for="description" class="form-label">Description</label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-text'></i></span>
          <textarea class="form-control" id="description" formControlName="description" rows="4" maxlength="2000"
            autocomplete="off" placeholder="Detailed description of the milestone"
            [ngClass]="{ 'is-invalid': submitted && f.description.errors }">
          </textarea>
          <div class="invalid-feedback" *ngIf="submitted && f.description.errors">
            <span *ngIf="f.description.errors.required">Description is required.</span>
            <span *ngIf="f.description.errors.maxlength">Character limit exceeded. Maximum 2000 characters
              allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 editor mt-3">
        <label for="notes" class="form-label">Notes</label>
        <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
        <ngx-editor [editor]="editor" formControlName="notes" [ngClass]="{'is-invalid': submitted && f.notes.errors}">
        </ngx-editor>
        <div class="invalid-feedback" *ngIf="submitted && f.notes.errors">
          <span *ngIf="f.notes.errors.required">Notes is required.</span>
          <span *ngIf="f.notes.errors.maxlength">Character limit exceeded. Maximum allowed is 2000 characters.</span>
        </div>
      </div>
      <div class="col-lg-auto ms-auto">
        <button type="submit" class="btn btn-secondary rcx-btn" #inProgress
          [ngClass]="{'no-event': inProgress?.value === 'true'}">
          <ng-container *ngIf="inProgress?.value === 'true'; else saveButtonText">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{milestoneForm.value.id ? 'Updating...' : 'Saving...'}}
          </ng-container>
          <ng-template #saveButtonText>
            <i class="bx bx-save"></i>{{milestoneForm.value.id ? 'Save Changes' : 'Save'}}
          </ng-template>
        </button>
      </div>
    </div>
  </div>
</form>
<div class="dotted-divider" *ngIf="milestoneForm?.value?.id"></div>
<section class="resource-management" *ngIf="milestoneForm?.value?.id">
  <div class="row">
    <div class="col-lg-12">
      <div>
        <div class="card-resourse">
          <h5 class="card-title">
            <i class="bx bx-list-ul me-1 text-primary"></i>Milestone Resources
          </h5>
        </div>
        <div class="container mt-2 resourse-container">
          <form [formGroup]="resourceForm">
            <div formArrayName="resources">
              <div class="card mb-3 position-relative" *ngFor="let resource of resources.controls; let i = index"
                [formGroupName]="i">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-center">
                    <h5 class="card-title">Resource {{ i + 1 }}</h5>
                    <div class="credential-actions">
                      <ng-container *ngIf="resource.value.id">
                        <button type="button" class="icon-button delete-button" (click)="deleteResource(resource, i)"
                          [disabled]="resource?.isDeleteInProgress">
                          <ng-container *ngIf="!resource?.isDeleteInProgress; else deleteLoading">
                            <i class="bx bx-trash"></i>
                          </ng-container>
                          <ng-template #deleteLoading>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          </ng-template>
                        </button>
                      </ng-container>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5">
                      <label for="label" class="form-label">File <b class="text-secondary">*</b></label>
                      <div class="input-group">
                        <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-user'></i></span>
                        <input type="text" class="form-control" id="label" formControlName="label" autocomplete="off"
                          placeholder="Enter File" [ngClass]="{'is-invalid': resourceSubmitted && resource.get('label')?.errors}" />
                        <div class="condition"></div>
                        <div class="invalid-feedback" *ngIf="resourceSubmitted && resource.get('label')?.errors">
                          <span *ngIf="resource.get('label')?.errors?.required">File is required.</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-7 d-flex align-items-end gap-2 flex-wrap">
                      <input type="file" id="fileInput-{{i}}" style="display: none"
                        accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.txt" (change)="handleFileInput($event, i)">
                      <button type="button" id="browseButton-{{i}}"
                        class="btn btn-secondary truncate-text d-flex align-items-center gap-1"
                        [ngClass]="{'is-invalid': resourceSubmitted && resource.get('fileUrl')?.errors}"
                        (click)="triggerFileInput(i)">
                        <i class="bx bx-upload"></i> {{ resource.value.fileUrl || 'Browse Files' }}
                      </button>
                      <ng-container *ngIf="resource?.value.fileUrl">
                        <button class="btn btn-outline-success d-flex align-items-center gap-1"
                          (click)="downloadFile(resource?.value.fileUrl, i)">
                          <i class="bx bx-download"></i> Download
                        </button>
                      </ng-container>
                      <div class="invalid-feedback d-block" *ngIf="resourceSubmitted && resource.get('fileUrl')?.errors">
                        <span *ngIf="resource.get('fileUrl')?.errors?.required">File is required.</span>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end btn-size">
                    <button type="submit" class="btn btn-secondary btn-submit" (click)="upsertResource(resource, i)"
                      [disabled]="resource?.isUpdateInProgress">
                      <ng-container *ngIf="resource?.isUpdateInProgress; else saveButtonText">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{ resource.value.id ? 'Updating...' : 'Saving...' }}
                      </ng-container>
                      <ng-template #saveButtonText>
                        <i class="bx bx-save"></i>
                        {{ resource.value.id ? 'Update' : 'Save' }}
                      </ng-template>
                    </button>
                  </div>
                </div>
              </div>
              <div class="text-center border-dotted mb-3">
                <button type="button" class="btn text-secondary" (click)="addResource()" [disabled]="isAddingResource">
                  <ng-container class="text-secondary" *ngIf="!isAddingResource; else addResourceLoading">
                    + Add New Resource
                  </ng-container>
                  <ng-template #addResourceLoading>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Adding...
                  </ng-template>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>